export function formatPersonLabel(name: string, surname?: string): string {
  return `${name} ${surname ?? ''}`.trim()
}
